// ─── Shared legend & weapon reference data ─────────────────────────────────────
// Single source of truth for legend portraits, weapon pairings, and display
// name formatting. Used by ProfilePage.tsx and ChecklistPage.tsx.

export type Role = "Founder" | "Officer" | "Member" | "Recruit";

// ─── Legend portraits (sourced from cms.brawlhalla.com) ───────────────────────
export const LEGEND_PORTRAITS: Record<string, string> = {
  "bodvar":      "https://cms.brawlhalla.com/c/uploads/2021/07/bodvar.png",
  "cassidy":     "https://cms.brawlhalla.com/c/uploads/2021/07/cassidy.png",
  "orion":       "https://cms.brawlhalla.com/c/uploads/2021/07/orion.png",
  "lord vraxx":  "https://cms.brawlhalla.com/c/uploads/2021/07/a_Roster_Pose_VraxxM-1.png",
  "gnash":       "https://cms.brawlhalla.com/c/uploads/2021/07/gnash.png",
  "queen nai":   "https://cms.brawlhalla.com/c/uploads/2021/07/nai.png",
  "hattori":     "https://cms.brawlhalla.com/c/uploads/2021/07/hattori.png",
  "sir roland":  "https://cms.brawlhalla.com/c/uploads/2021/07/roland.png",
  "scarlet":     "https://cms.brawlhalla.com/c/uploads/2021/07/scarlet.png",
  "thatch":      "https://cms.brawlhalla.com/c/uploads/2021/07/thatch.png",
  "ada":         "https://cms.brawlhalla.com/c/uploads/2021/07/ada.png",
  "sentinel":    "https://cms.brawlhalla.com/c/uploads/2021/07/sentinel.png",
  "lucien":      "https://cms.brawlhalla.com/c/uploads/2021/07/lucien.png",
  "teros":       "https://cms.brawlhalla.com/c/uploads/2021/07/teros.png",
  "brynn":       "https://cms.brawlhalla.com/c/uploads/2021/07/a_Roster_Pose_ValkyrieM.png",
  "asuri":       "https://cms.brawlhalla.com/c/uploads/2021/07/a_Roster_Pose_CatM.png",
  "barraza":     "https://cms.brawlhalla.com/c/uploads/2021/07/a_Roster_Pose_ApocM.png",
  "ember":       "https://cms.brawlhalla.com/c/uploads/2021/07/a_Roster_Pose_ElfM.png",
  "azoth":       "https://cms.brawlhalla.com/c/uploads/2021/07/a_Roster_Pose_AzothM.png",
  "koji":        "https://cms.brawlhalla.com/c/uploads/2021/07/a_Roster_Pose_SamuraiM.png",
  "ulgrim":      "https://cms.brawlhalla.com/c/uploads/2021/07/a_Roster_Pose_DwarfM.png",
  "diana":       "https://cms.brawlhalla.com/c/uploads/2021/07/a_Roster_Pose_MonsterHunterM.png",
  "jhala":       "https://cms.brawlhalla.com/c/uploads/2021/07/a_Roster_Pose_BarbarianM.png",
  "kor":         "https://cms.brawlhalla.com/c/uploads/2021/07/a_Roster_Pose_GolemM.png",
  "wu shang":    "https://cms.brawlhalla.com/c/uploads/2021/07/a_Roster_Pose_MonkM.png",
  "val":         "https://cms.brawlhalla.com/c/uploads/2021/07/a_Roster_Pose_ValM.png",
  "ragnir":      "https://cms.brawlhalla.com/c/uploads/2021/07/a_Roster_Pose_DragonM.png",
  "cross":       "https://cms.brawlhalla.com/c/uploads/2021/07/a_Roster_Pose_CrossM.png",
  "mirage":      "https://cms.brawlhalla.com/c/uploads/2021/07/a_Roster_Pose_AssassinM.png",
  "nix":         "https://cms.brawlhalla.com/c/uploads/2021/07/a_Roster_Pose_ReaperM.png",
  "mordex":      "https://cms.brawlhalla.com/c/uploads/2021/07/a_Roster_Pose_WerewolfM.png",
  "yumiko":      "https://cms.brawlhalla.com/c/uploads/2021/07/a_Roster_Pose_KitsuneM.png",
  "artemis":     "https://cms.brawlhalla.com/c/uploads/2021/07/a_Roster_Pose_SpaceHunterM.png",
  "caspian":     "https://cms.brawlhalla.com/c/uploads/2021/07/a_Roster_Pose_ThiefM.png",
  "sidra":       "https://cms.brawlhalla.com/c/uploads/2021/07/a_Roster_Pose_CorsairM.png",
  "xull":        "https://cms.brawlhalla.com/c/uploads/2021/07/a_Roster_Pose_BruteM.png",
  "kaya":        "https://cms.brawlhalla.com/c/uploads/2021/07/a_Roster_Pose_InuitM-1.png",
  "isaiah":      "https://cms.brawlhalla.com/c/uploads/2021/07/a_Roster_Pose_SoldierM.png",
  "jiro":        "https://cms.brawlhalla.com/c/uploads/2021/07/a_Roster_Pose_ShinobiM.png",
  "lin fei":     "https://cms.brawlhalla.com/c/uploads/2021/07/a_Roster_Pose_WuxiaM.png",
  "zariel":      "https://cms.brawlhalla.com/c/uploads/2021/07/a_Roster_Pose_CelestialM.png",
  "rayman":      "https://cms.brawlhalla.com/c/uploads/2021/07/a_Roster_Pose_RaymanM.png",
  "dusk":        "https://cms.brawlhalla.com/c/uploads/2021/07/a_Roster_Pose_ElfwarM.png",
  "fait":        "https://cms.brawlhalla.com/c/uploads/2021/07/a_Roster_Pose_SpellwitchM.png",
  "thor":        "https://cms.brawlhalla.com/c/uploads/2021/07/a_Roster_Pose_ThorM.png",
  "petra":       "https://cms.brawlhalla.com/c/uploads/2021/07/a_Roster_Pose_RagefighterM.png",
  "vector":      "https://cms.brawlhalla.com/c/uploads/2021/07/a_Roster_Pose_ActualRobotM.png",
  "volkov":      "https://cms.brawlhalla.com/c/uploads/2021/07/a_Roster_Pose_VampLordM.png",
  "onyx":        "https://cms.brawlhalla.com/c/uploads/2021/07/a_Roster_Pose_GargoyleM.png",
  "jaeyun":      "https://cms.brawlhalla.com/c/uploads/2021/07/a_Roster_Pose_SellswordM.png",
  "mako":        "https://cms.brawlhalla.com/c/uploads/2021/07/a_Roster_Pose_ActualSharkM.png",
  "magyar":      "https://cms.brawlhalla.com/c/uploads/2021/07/a_Roster_Pose_GhostArmorM.png",
  "reno":        "https://cms.brawlhalla.com/c/uploads/2021/07/a_Roster_Pose_BountyHunterM.png",
  "munin":       "https://cms.brawlhalla.com/c/uploads/2021/12/a_Roster_Pose_BirdBardM.png",
  "arcadia":     "https://cms.brawlhalla.com/c/uploads/2022/03/a_Roster_Pose_FairyQueenM.png",
  "ezio":        "https://cms.brawlhalla.com/c/uploads/2022/07/a_Roster_Pose_EzioM.png",
  "tezca":       "https://cms.brawlhalla.com/c/uploads/2022/12/a_Roster_Pose_LuchadorM.png",
  "thea":        "https://cms.brawlhalla.com/c/uploads/2023/03/a_Roster_Pose_SpeedsterM.png",
  "redraptor":   "https://cms.brawlhalla.com/c/uploads/2023/06/a_Roster_Pose_SentaiM.png",
  "loki":        "https://cms.brawlhalla.com/c/uploads/2023/09/Loki_icon-1.png",
  "seven":       "https://cms.brawlhalla.com/c/uploads/2023/12/roboengineer-rostericon.png",
  "vivi":        "https://cms.brawlhalla.com/c/uploads/2024/08/a_Roster_Pose_ViviL.png",
  "imugi":       "https://cms.brawlhalla.com/c/uploads/2024/07/imgui-icon.png",
  "king zuva":   "https://cms.brawlhalla.com/c/uploads/2024/10/a_Roster_Pose_ZuvaM.png",
  "priya":       "https://cms.brawlhalla.com/c/uploads/2025/01/Mobile-icon.png",
  "ransom":      "https://cms.brawlhalla.com/c/uploads/2025/06/a_Roster_Pose_CybervirusM.png",
  "lady vera":   "https://cms.brawlhalla.com/c/uploads/2025/11/a_Roster_Pose_ClericM.png",
  "rupture":     "https://cms.brawlhalla.com/c/uploads/2026/01/a_Roster_Pose_DarkheartMonsterM.png",
  "aurus":       "https://cms.brawlhalla.com/c/uploads/2026/06/a_Roster_Pose_GladiatorM.png",
};

export function legendPortrait(nameKey: string): string | undefined {
  return LEGEND_PORTRAITS[nameKey.toLowerCase()];
}

// ─── Legend weapon pairings ────────────────────────────────────────────────────
// NOTE: fixed Cassidy's weapon-one from "Pistol" (not a real weapon type, likely
// a typo) to "Blasters" to match the rest of the roster and ALL_WEAPONS below.
export const LEGEND_WEAPONS: Record<string, [string, string]> = {
  "bodvar":      ["Hammer", "Sword"],
  "cassidy":     ["Blasters", "Hammer"],
  "orion":       ["Spear", "Rocket Lance"],
  "lord vraxx":  ["Rocket Lance", "Blasters"],
  "gnash":       ["Hammer", "Spear"],
  "queen nai":   ["Spear", "Katars"],
  "hattori":     ["Sword", "Spear"],
  "sir roland":  ["Sword", "Rocket Lance"],
  "scarlet":     ["Hammer", "Rocket Lance"],
  "thatch":      ["Sword", "Blasters"],
  "ada":         ["Blasters", "Spear"],
  "sentinel":    ["Katars", "Hammer"],
  "lucien":      ["Katars", "Blasters"],
  "teros":       ["Axe", "Hammer"],
  "brynn":       ["Axe", "Spear"],
  "asuri":       ["Sword", "Katars"],
  "barraza":     ["Axe", "Blasters"],
  "ember":       ["Bow", "Katars"],
  "azoth":       ["Axe", "Bow"],
  "koji":        ["Sword", "Bow"],
  "ulgrim":      ["Axe", "Rocket Lance"],
  "diana":       ["Blasters", "Bow"],
  "jhala":       ["Axe", "Sword"],
  "kor":         ["Hammer", "Gauntlets"],
  "wu shang":    ["Gauntlets", "Spear"],
  "val":         ["Sword", "Gauntlets"],
  "ragnir":      ["Axe", "Katars"],
  "cross":       ["Blasters", "Gauntlets"],
  "mirage":      ["Scythe", "Spear"],
  "nix":         ["Scythe", "Blasters"],
  "mordex":      ["Gauntlets", "Scythe"],
  "yumiko":      ["Bow", "Hammer"],
  "artemis":     ["Rocket Lance", "Scythe"],
  "caspian":     ["Gauntlets", "Katars"],
  "sidra":       ["Sword", "Cannon"],
  "xull":        ["Axe", "Cannon"],
  "kaya":        ["Spear", "Bow"],
  "isaiah":      ["Blasters", "Cannon"],
  "jiro":        ["Sword", "Scythe"],
  "lin fei":     ["Katars", "Cannon"],
  "zariel":      ["Gauntlets", "Bow"],
  "rayman":      ["Axe", "Gauntlets"],
  "dusk":        ["Orb", "Spear"],
  "fait":        ["Scythe", "Orb"],
  "thor":        ["Hammer", "Orb"],
  "petra":       ["Orb", "Gauntlets"],
  "vector":      ["Rocket Lance", "Bow"],
  "volkov":      ["Scythe", "Axe"],
  "onyx":        ["Cannon", "Gauntlets"],
  "jaeyun":      ["Sword", "Greatsword"],
  "mako":        ["Greatsword", "Katars"],
  "magyar":      ["Greatsword", "Hammer"],
  "reno":        ["Blasters", "Orb"],
  "munin":       ["Scythe", "Bow"],
  "arcadia":     ["Greatsword", "Spear"],
  "ezio":        ["Sword", "Orb"],
  "tezca":       ["Battle Boots", "Gauntlets"],
  "thea":        ["Rocket Lance", "Battle Boots"],
  "redraptor":   ["Orb", "Battle Boots"],
  "loki":        ["Scythe", "Katars"],
  "seven":       ["Cannon", "Spear"],
  "vivi":        ["Battle Boots", "Blasters"],
  "imugi":       ["Greatsword", "Axe"],
  "king zuva":   ["Hammer", "Battle Boots"],
  "priya":       ["Sword", "Chakram"],
  "ransom":      ["Chakram", "Bow"],
  "lady vera":   ["Scythe", "Chakram"],
  "rupture":     ["Rocket Lance", "Katars"],
  "aurus":       ["Spear", "Chakram"],
};

export const ALL_WEAPONS = [
  "Axe", "Battle Boots", "Blasters", "Bow", "Cannon", "Chakram",
  "Gauntlets", "Greatsword", "Hammer", "Katars", "Orb",
  "Rocket Lance", "Scythe", "Spear", "Sword",
];

// ─── Weapon icons ───────────────────────────────────────────────────────────
// No equivalent exists elsewhere on the site (ProfilePage only lists weapon
// names for filtering), so this is the single source of truth going forward.
export const WEAPON_ICONS: Record<string, string> = {
  "Katars": "https://tiermaker.com/images/template_images/2022/1063108/brawlhalla-weapons-with-battle-boots-1063108/katars-iconpng.png",
  "Blasters": "https://tiermaker.com/images/template_images/2022/1063108/brawlhalla-weapons-with-battle-boots-1063108/blasters-iconpng.png",
  "Sword": "https://tiermaker.com/images/template_images/2022/1063108/brawlhalla-weapons-with-battle-boots-1063108/sword-iconpng.png",
  "Axe": "https://tiermaker.com/images/template_images/2022/1063108/brawlhalla-weapons-with-battle-boots-1063108/axe-iconpng.png",
  "Greatsword": "https://tiermaker.com/images/template_images/2022/1063108/brawlhalla-weapons-with-battle-boots-1063108/greatsword-iconpng.png",
  "Gauntlets": "https://tiermaker.com/images/template_images/2022/1063108/brawlhalla-weapons-with-battle-boots-1063108/gauntlets-iconpng.png",
  "Rocket Lance": "https://brawlhalla.wiki.gg/images/thumb/Rocket_Lance_Icon.png/54px-Rocket_Lance_Icon.png?39ae3b",
  "Hammer": "https://tiermaker.com/images/template_images/2022/1063108/brawlhalla-weapons-with-battle-boots-1063108/hammer-iconpng.png",
  "Scythe": "https://tiermaker.com/images/template_images/2022/1063108/brawlhalla-weapons-with-battle-boots-1063108/scythe-iconpng.png",
  "Chakram": "https://brawlhalla.wiki.gg/images/thumb/Chakram_Icon.png/54px-Chakram_Icon.png?1d6946",
  "Battle Boots": "https://brawlhalla.wiki.gg/images/thumb/Battle_Boots_Icon.png/54px-Battle_Boots_Icon.png?7c5c70",
  "Orb": "https://tiermaker.com/images/template_images/2022/1063108/brawlhalla-weapons-with-battle-boots-1063108/orb-iconpng.png",
  "Bow": "https://tiermaker.com/images/template_images/2022/1063108/brawlhalla-weapons-with-battle-boots-1063108/bow-iconpng.png",
  "Cannon": "https://tiermaker.com/images/template_images/2022/1063108/brawlhalla-weapons-with-battle-boots-1063108/cannon-iconpng.png",
  "Spear": "https://tiermaker.com/images/template_images/2022/1063108/brawlhalla-weapons-with-battle-boots-1063108/spear-iconpng.png",
};

export const LEGEND_DISPLAY_NAMES: Record<string, string> = {
  "redraptor": "Red Raptor",
};

export function capitalize(s: string): string {
  if (LEGEND_DISPLAY_NAMES[s.toLowerCase()]) return LEGEND_DISPLAY_NAMES[s.toLowerCase()];
  return s.split(" ").map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(" ");
}

export const roleIcons: Record<Role, string> = {
  Recruit: "/ranks/recruit.png",
  Member:  "/ranks/member.png",
  Officer: "/ranks/officer.png",
  Founder: "/ranks/founder.png",
};
